import { render } from "./AboutBanner.vue?vue&type=template&id=6860ab86&scoped=true"
import script from "./AboutBanner.vue?vue&type=script&lang=js"
export * from "./AboutBanner.vue?vue&type=script&lang=js"

import "./AboutBanner.vue?vue&type=style&index=0&id=6860ab86&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6860ab86"]])

export default __exports__